import React, { Component } from 'react'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import './css/index.css'
import join from '../../assets/image/join.jpg'
import insight2 from '../../assets/image/insight2.jpg'
import insight4 from '../../assets/image/insight4.jpg'
import chevron from '../../assets/image/chevron-down.svg'
import Chevron from '../../assets/image/chevron-right.svg'
import {Button,Collapse} from '@material-ui/core'
import {data_careers} from '../../dummy/data'
import {connect} from 'react-redux'
import Skeleton  from 'react-loading-skeleton';

import {getCareer} from '../../redux/action/career'
class index extends Component {
    state={
        collapse1:false,
        left:[],
        right:[]
    }
    componentDidMount(){
        this.props.getCareer()
        
    }
    componentWillReceiveProps(newProps){
        let career=newProps.career.list_career
        if(career!==null){
            let left=[]
            let right=[]
            let a=career.length/2
            let b=Math.round(a)
            console.log('b',b)
            career.map((data,i)=>{
                if(i>=b){
                    right.push(data)
                    
                }else{
                    left.push(data)
                }
            })
            this.setState({left,right})
        }
        
    }
    collapseToggle=(jobs)=>{
        console.log('jobs', jobs)
        // this.setState({collapse1:!this.state.collapse1})
        this.setState({[jobs]:!this.state[jobs]})
    }
    loader=()=>{
        return(
            <div className='loader-careers-list-grid'>
                <Skeleton height={100}/>
                <Skeleton height={100}/>
                <Skeleton height={100}/>
                <Skeleton height={100}/>
            </div>
        )
    }
    render() {
        const {collapse1,left,right}=this.state
        const {career,general   }=this.props
        console.log('career', left,right)
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br/>
                <section className='careers-page'>
                    <h1>Join One GML</h1>
                    <br/><br/>
                    <div className='careers-grid'>
                        <div className='big-grid'>
                            <img src={join} className='careers-grid-image'/>
                        </div>
                        <div className='small-grid'>
                            <img src={insight2} className='careers-grid-image'/>
                        </div>
                        <div className='small-grid'>
                            <img src={insight4} className='careers-grid-image'/>
                        </div>
                    </div>
                    <br/><br/>
                    <p>We seek a broad range of skills—from digital to<br/> interpersonal to analytical. Join us to make a lasting impact on our nation,<br/> industries, and society.</p>
                    <br/><br/>
                    <h1>Open Position</h1>
                    <br/><br/>
                    {/* <div className='careers-wrapper-grid'>
                        <div className='careers-left'>
                        {left.map((data,i)=>(
                            <div  className={`${this.state[i]}left`?'left':''}   style={{minHeight:50}} key={i}>
                                <div className='careers-title' onClick={()=>this.collapseToggle(`${i}left`)}>
                                    <h6 >{data.title}<br/><span><p>{data.place}</p></span></h6>
                                    <img src={chevron} className={this.state[i]?'active-chevron':'chevron-blue'}  onClick={()=>this.collapseToggle(`${i}left`)}/>
                                </div>
                                <br/>
                                <Collapse in={this.state[`${i}left`]}>
                                    <div className='careers-collapse'>
                                        <div dangerouslySetInnerHTML={{__html:data.description}}></div>
                                        <br/><br/>
                                        <p>Send to :  <a  href="mailto:hrd@gmlperformance.co.id">hrd@gmlperformance.co.id</a> </p>
                                        <p>Subject : {data.title}</p>
                                    </div>
                                </Collapse>
                            </div>
                        ))}
                        </div>
                        <div className='careers-right'>
                        {right.map((data,i)=>(
                            <div className={`${this.state[i]}right`?'right':''} style={{minHeight:50}} key={i}>
                                <div className='careers-title' onClick={()=>this.collapseToggle(`${i}right`)}>
                                    <h6 >{data.title}<br/><span><p>{data.place}</p></span></h6>
                                    <img src={chevron} className={this.state[i]?'active-chevron':'chevron-blue'}  onClick={()=>this.collapseToggle(`${i}right`)}/>
                                </div>
                                <br/>
                                <Collapse in={this.state[`${i}right`]}>
                                    <div className='careers-collapse'>
                                        <div dangerouslySetInnerHTML={{__html:data.description}}></div>
                                        <br/><br/>
                                        <p>Send to :  <a  href="mailto:hrd@gmlperformance.co.id">hrd@gmlperformance.co.id</a> </p>
                                        <p>Subject : {data.title}</p>
                                    </div>
                                </Collapse>
                            </div>
                        ))}
                        </div>
                    </div> */}
                    {general.isLoading!==true&&career.list_career!==null?
                    <div className='career-wrap'>
                        <div className='career-left'>
                        {left.map((data,i)=>(
                                <div >
                                <div className='careers-title' onClick={()=>this.collapseToggle(`${i}-left`)}>
                                    <h6 >{data.title}<br/><span><p>{data.location}</p></span></h6>
                                    <img src={chevron} className={this.state[`${i}-left`]?'active-chevron':'chevron-blue'}  onClick={()=>this.collapseToggle(i)}/>
                                </div>
                                <br/>
                                <Collapse in={this.state[`${i}-left`]}>
                                    <div className='careers-collapse'>
                                        <div dangerouslySetInnerHTML={{__html:data.description}}></div>
                                        {/* <br/><br/>
                                        <p>Send to :  <a  href="mailto:hrd@gmlperformance.co.id">hrd@gmlperformance.co.id</a> </p>
                                        <p>Subject : {data.subject}</p> */}
                                    </div>
                                </Collapse>
                            </div>
                        ))}
                        </div>
                        <div className='career-right'>
                        {right.map((data,i)=>(
                                <div >
                                <div className='careers-title' onClick={()=>this.collapseToggle(`${i}-right`)}>
                                    <h6 >{data.title}<br/><span><p>{data.location}</p></span></h6>
                                    <img src={chevron} className={this.state[`${i}-right`]?'active-chevron':'chevron-blue'}  onClick={()=>this.collapseToggle(i)}/>
                                </div>
                                <br/>
                                <Collapse in={this.state[`${i}-right`]}>
                                    <div className='careers-collapse'>
                                        <div dangerouslySetInnerHTML={{__html:data.description}}></div>
                                        {/* <br/><br/>
                                        <p>Send to :  <a  href="mailto:hrd@gmlperformance.co.id">hrd@gmlperformance.co.id</a> </p>
                                        <p>Subject : {data.title}</p> */}
                                    </div>
                                </Collapse>
                            </div>
                        ))}
                        </div>
                    </div>
                    // <div className='careers-flex'>
                    //     {left.map((data,i)=>(
                        // <div >
                        //     <div className='careers-title' onClick={()=>this.collapseToggle(i)}>
                        //         <h6 >{data.title}<br/><span><p>{data.location}</p></span></h6>
                        //         <img src={chevron} className={this.state[i]?'active-chevron':'chevron-blue'}  onClick={()=>this.collapseToggle(i)}/>
                        //     </div>
                        //     <br/>
                        //     <Collapse in={this.state[i]}>
                        //         <div className='careers-collapse'>
                        //             <div dangerouslySetInnerHTML={{__html:data.description}}></div>
                        //             <br/><br/>
                        //             <p>Send to :  <a  href="mailto:hrd@gmlperformance.co.id">hrd@gmlperformance.co.id</a> </p>
                        //             <p>Subject : {data.title}</p>
                        //         </div>
                        //     </Collapse>
                        // </div>
                    //     ))}
                    // </div>
                    // <div className='careers-list-grid'>
                    //     {career.list_career.map((data,i)=>(
                    //         <div className={this.state[i]?'left':''}  style={{minHeight:50}} key={i}>
                                // <div className='careers-title' onClick={()=>this.collapseToggle(i)}>
                                //     <h6 >{data.title}<br/><span><p>{data.location}</p></span></h6>
                                //     <img src={chevron} className={this.state[i]?'active-chevron':'chevron-blue'}  onClick={()=>this.collapseToggle(i)}/>
                                // </div>
                                // <br/>
                                // <Collapse in={this.state[i]}>
                                //     <div className='careers-collapse'>
                                //         <div dangerouslySetInnerHTML={{__html:data.description}}></div>
                                //         <br/><br/>
                                //         <p>Send to :  <a  href="mailto:hrd@gmlperformance.co.id">hrd@gmlperformance.co.id</a> </p>
                                //         <p>Subject : {data.title}</p>
                                //     </div>
                                // </Collapse>
                    //         </div>
                    //     ))}
                        
                        
                    // </div>
                    :this.loader()}
                </section>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
const mapStateToProps=(state)=>({
    career:state.career,
    general:state.general,

})
const mapDispatchToProps={
    getCareer
}
export default connect(mapStateToProps,mapDispatchToProps)(index)